export default "__VITE_ASSET__BuJ2P0iz__"